import { COLUMNS_CHANGED } from '../../views/actions/viewsActionTypes';
import { RESTORE_CACHED_VALUES } from '../init/actions/initActionTypes';
export const tableViewConfigReducer = (state, action) => {
  switch (action.type) {
    case COLUMNS_CHANGED:
      {
        const {
          columns,
          state: newState
        } = action.payload;
        return state.with(Object.assign({
          columns: columns === null || columns === void 0 ? void 0 : columns.map(c => ({
            propertyName: c.name
          }))
        }, newState && {
          numberOfFrozenColumns: newState === null || newState === void 0 ? void 0 : newState.numberOfFrozenColumns
        }));
      }
    case RESTORE_CACHED_VALUES:
      {
        const {
          views,
          viewId,
          hasData
        } = action.payload;
        if (!hasData) {
          return state;
        }
        const restoreView = views[viewId];
        if (!restoreView) {
          return state;
        }
        return state.with({
          columns: restoreView.columns.map(c => ({
            propertyName: c.name
          }))
          // Doesn't look like we need to restore the number of frozen columns
        });
      }
    default:
      return state;
  }
};
export const reduceActionsToTableViewConfig = (viewConfig, actions) => {
  return actions.reduce((state, action) => {
    return tableViewConfigReducer(state, action);
  }, viewConfig);
};